<template>
    <section>
	
        <!--<div class="container">
            <div class="row">
                <div class="col p-5">
                    <h1 class="font-weight-bold text-danger text-uppercase text-center mb-4">Pendaftaran Siswa BTA Group 2023/2024</h1>
                    <p class="font-weight-medium mb-5">
                        Mohon diisi form berikut secara lengkap dan benar. 
			Setelah selesai mengisi sampai tahap akhir, akan mendapatkan pesan konfirmasi yang masuk ke e-mail yang terdaftar.
                    </p>
		    
		    <h2 class="font-weight-bold text-danger text-uppercase text-center mb-5">
                        Produk Kami
                    </h2>

                    <div class="row">
                        <div class="col-12 col-lg-6 mb-5" v-for="product in products">
                            <div class="row mb-3">
                                <div class="col-7 pr-2">
                                    <img v-bind:src="product.imageUrl" class="img-fluid w-100" />
                                </div>
                                <div class="col-5 pl-2">
                                    <h3 class="font-weight-bold text-danger text-uppercase">{{ product.name }}</h3>
                                    <h3 class="font-weight-bold">{{ product.price | currency }}</h3>
                                    <a href="#" v-on:click.prevent="modal = true; reference = product" class="d-block mb-5">
                                        Cabang Tersedia
                                    </a>
                                    <router-link v-bind:to="{ name: 'product/registration', params: {id: product.id} }" class="btn btn-danger btn-sm position-absolute px-5 mx-2" style="left: 0px; bottom: 0px;">
                                        Pilih
                                    </router-link>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p class="font-weight-medium">
                                        {{ product.description }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
        
        <div>    
          <div class="row pt-4 pb-5">
            <div class="col-12 mx-auto text-center cabang-wrapper">
              <h3 class="font-weight-bold text-dark section-title mb-3">
                  Pilih Cabang Terdekat Anda
              </h3>
              <p class="text-secondary mb-5 font-weight-medium">
                  Klik logo cabang di bawah ini untuk terhubung langsung via chat WhatsApp <br class="d-none d-md-block">dan dapatkan informasi lebih lanjut.
              </p>
              
              <div class="row justify-content-center px-2 px-md-5">
                      <div v-for="(branch, index) in displayBranches" v-bind:key="branch.id || index" class="col-6 col-md-4 col-xl-3 mb-4">
                          <a v-bind:href="getWaLink(branch)" class="cabang-link" target="_blank">
                              <div class="cabang-card">
                                  <img v-bind:src="branch.imageUrl" v-bind:alt="branch.name">
                              </div>
                          </a>
                      </div>                      
               </div>
            </div>
          </div>
        </div>

        <b-modal v-model="modal" v-on:hide="reference = null" size="lg" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Cabang-Cabang Tersedia
                </h4>
            </template>
            <div class="container px-5 py-2">
                <button v-on:click="modal = false" class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto">
                    Kembali
                </button>
                <p class="font-weight-medium text-center mb-1">
                    Berikut adalah cabang-cabang yang menyediakan:
                </p>
                <template v-if="reference">
                    <p class="font-weight-bold text-center">
                        {{ reference.name }}
                    </p>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <h4 class="font-weight-bold">Cabang Utama:</h4>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3 font-weight-medium">
                                    <li v-for="branch in primaryBranches">{{ branch.name }}</li>
                                </ul>  
                            </p>
                        </div>
                        <div class="col-auto">
                            <h4 class="font-weight-bold">Cabang Mitra:</h4>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3 font-weight-medium">
                                    <li v-for="branch in partnerBranches">{{ branch.name }}</li>
                                </ul>  
                            </p>
                        </div>
                        <div class="col-auto">
                            <h4 class="font-weight-bold">Cabang PP:</h4>
                            <p class="mb-2">
                                <ul class="mb-0 pl-3 font-weight-medium">
                                    <li v-for="branch in otherBranches">{{ branch.name }}</li>
                                </ul>  
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </b-modal>
	<div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ProductIndex",
        data() {
            return {
                products: [],
								displayBranches: [],
		googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                reference: null,
                modal: false
            };
        },
				methods: {
            getWaLink(branch) {
                let phone = '';
                if (branch.address) {
                    const match = branch.address.match(/wa(?:hatsapp)?.*?((?:0|62)8[\d\-\s+]{6,})/i);
                    if (match) {
                        phone = match[1].replace(/\D/g, '');
                        if (phone.startsWith('0')) {
                            phone = '62' + phone.substring(1);
                        }
                    } else {
                        const fallbackMatch = branch.address.match(/(?:62|0)8\d{8,11}/);
                        if (fallbackMatch) {
                            phone = fallbackMatch[0].replace(/\D/g, '');
                            if (phone.startsWith('0')) {
                               phone = '62' + phone.substring(1);
                            }
                        }
                    }
                }
                const text = encodeURIComponent(`Halo, boleh tanya mengenai Program Bimbingan di ${branch.name}?`);
                return `https://api.whatsapp.com/send?phone=${phone}&text=${text}`;
            }
        },
        computed: {
            primaryBranches() {
                return this.reference ? this.reference.branches.filter(branch => branch.isPrimary) : [];
            },
            partnerBranches() {
                return this.reference ? this.reference.branches.filter(branch => !branch.isPrimary && !branch.isHidden) : [];
            },
            otherBranches() {
                return this.reference ? this.reference.branches.filter(branch => !branch.isPrimary && branch.isHidden) : [];
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/product').then(response => {
                this.products = response.data.data;
            });
						this.axios.get(process.env.API_URL + '/branch', {params: {isHidden: false}}).then(response => {
                this.displayBranches = response.data.data.filter(branch => branch.isPrimary);
            });
        },
        mounted() {
            document.title = 'Product - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
.cabang-card {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
    background-color: transparent;
    border-radius: 12px;
    padding: 20px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cabang-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
}

.cabang-card img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.cabang-link {
    display: block;
    text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/product/Index.vue